function review() {
    $('.e-seemore').click(function () {
        const $btn = $(this);
        const isActive = $btn.hasClass('active');

        if (!isActive) {
            // First click: store hidden items, show them, change text
            const $hiddenCards = $('.product-card:hidden');
            $btn.data('hiddenCards', $hiddenCards); // store for later

            $hiddenCards.slideDown();
            $btn.addClass('active');
            $btn.find('p').text('See Less Of The List');
        } else {
            // Second click: hide previously shown items only
            const $hiddenCards = $btn.data('hiddenCards');
            if ($hiddenCards) $hiddenCards.slideUp();

            $btn.removeClass('active');
            $btn.find('p').text('See More Of The List');
        }
    });

    $('.btn-backtotop').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });
}

export {review};
